module.exports = __webpack_public_path__ + "img/bg3.b48afbb9.png";